import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left\"><defs><style type=\"text/css\"></style></defs><path d=\"M0.2048 512c-0.0512-6.656 2.4064-13.2608 7.4752-18.2784l325.8368-325.8368a25.6 25.6 0 1 1 36.1984 36.1984L87.2448 486.6048h911.36a25.6 25.6 0 1 1 0 51.2H87.552l282.112 282.112a25.6 25.6 0 0 1-36.1984 36.1984L7.68 530.2784a25.4976 25.4976 0 0 1-7.4752-18.0736V512z\" fill=\"#000000\" p-id=\"750\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol